var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformationTooltip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.06,
    height: 39.06,
    viewBox: "0 0 39.06 39.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-information-circle-outline",
    "data-name": "Icon ionic-ios-information-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M16.552,12.577a1.935,1.935,0,1,1,1.925,1.878A1.88,1.88,0,0,1,16.552,12.577Zm.131,3.352H20.27v13.53H16.683Z",
    transform: "translate(4.419 2.459)",
    fill: "#6c89d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M22.9,6a16.894,16.894,0,1,1-11.953,4.948A16.789,16.789,0,0,1,22.9,6m0-2.629A19.53,19.53,0,1,0,42.435,22.9,19.527,19.527,0,0,0,22.9,3.375Z",
    transform: "translate(0 0)",
    fill: "#6c89d8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationTooltip);
export default __webpack_public_path__ + "static/media/InformationTooltip.c79ae809e68b650571e23345bafa1a25.svg";
export { ForwardRef as ReactComponent };